import { render, staticRenderFns } from "./addDeliver.vue?vue&type=template&id=b94bc42e&scoped=true&"
import script from "./addDeliver.vue?vue&type=script&lang=js&"
export * from "./addDeliver.vue?vue&type=script&lang=js&"
import style0 from "./addDeliver.vue?vue&type=style&index=0&id=b94bc42e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94bc42e",
  null
  
)

export default component.exports